<template>
  <div id="data-view4">
    <div class="flex h-100 flex-wrap pagebg" style="overflow: hidden">
      <!-- 加载动画 -->
      <div class="loads" v-show="isload">
        <dv-loading style="width: 250px; height: 250px">Loading...</dv-loading>
      </div>

      <div class="etime">{{ nowTime }}</div>
      <div class="etime1">最后更新:{{ updateTimeText }}</div>


      <div @click="signOut" class="power">
        <i style="cursor: pointer" class="el-icon-back"></i>
      </div>
      <div class="logoImg">
        <img style="height: 0.8rem" :src="logoSrc" />
      </div>
      <header class="w-100 h-10 flex j-center a-center">
        <dv-decoration-5 :dur="10" style="position: absolute; bottom: 0; right: 0; height: 50%" class="w-100" />
        <div class="font-big font-weight light-title" style="font-size:0.7rem;">
          {{ title }}
        </div>
      </header>
      <div style="text-align:center;width: 100%;">
        <img :src="qrcodeValue" class="aclass">
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/utils/api";
import format from "date-fns/format";
import router from "../../../../router";

export default {
  name: "board",
  data() {
    return {
      logoSrc: "/assets/img/logo_light.png",
      qrcodeValue: '',
      websock: null,
      isload: false,
      reconnectData: null,
      lockReconnect: false,
      title: "扫码签到",
      msg: "home",
      dataSet: {},
      now: new Date(),
      dataList: this.beans,
      startCharts: null,
      beans: {
        type: Array,
        default: function () {
          return [];
        },
      },
      nowTime: null,
      weekTime: null,
      updateTimeText: null,
    };
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.dataList = val;
        var data = [];
        for (var i = 0; i < this.dataList.length; i++) {
          console.log('--:', this.dataList[i]);
          var date = this.dataList[i]["date"];
          date = '<span style=\'font-size: 0.24rem;\'>' + date + '</span>';

          var status = this.dataList[i]["status"];
          switch (status) {
            case 2:
              status = '客户质量问题';
              break;
            case 1:
              status = '内部质量问题';
              break;
            case 0:
              status = '无质量问题';
              break;
          }
          status = '<span style=\'font-size: 0.24rem;\'>' + status + '</span>';
          var remark = this.dataList[i]["remark"];
          remark = '<span style=\'font-size: 0.24rem;\'>' + remark + '</span>';
          var value = [date, status, remark];
          data.push(value);
        }

        this.config = {
          startCharts: "",
          header: ["<span style='font-size: 0.24rem;'>发生日期</span>",
            "<span style='font-size: 0.24rem;'>事件类型</span>",
            "<span style='font-size: 0.24rem;'>事件描述</span>"],
          headerBGC: "rgba(6, 30, 93, 0.5)",
          headerHeight: this.fontSize(0.5),
          oddRowBGC: "rgba(0, 44, 81, 0.8)",
          evenRowBGC: "rgba(10, 29, 50, 0.8)",
          rowNum: 3,
          columnWidth: [this.fontSize(5), this.fontSize(10), this.fontSize(30)],
          align: ['center', 'center', 'center'],
          data: data,
        };
      },
      deep: true,
    },
  },
  mounted() {
    this.oepnRegisterialog();
    //钟表
    setInterval(this.clock, 1000);
  },
  destroyed() {
    if (this.websock) {
      this.lockReconnect = true;
      this.websock.close();
    }
  },
  filters: {},
  methods: {
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
    oepnRegisterialog() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
      }

      API.loadTheme().then((re) => {
        if (re.success && re["list"].length > 0) {
          this.logoSrc = re["list"][0]["icon"];
        }
      });

      var bean = { "uuid": "" };
      API.getOeeRegister(bean)
        .then((res) => {
          if (res.success) {
            var plan = res['value']
            this.qrcodeValue = `${user.http}/api/oee/register_plan/app_qrcode/` + plan.code;
          }
          var now = new Date();
          this.updateTimeText = format(now, "MM-dd HH:mm:ss");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    clock() {
      //全局变量d，创建Date对象
      var d = new Date();
      //格式：2018-2-5  19:19:33
      this.nowTime = format(d, "yyyy-MM-dd HH:mm:ss");
      var weekTime = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      )[d.getDay()];
      this.weekTime = weekTime;
    },
    signOut() {
      router.back();
    },
    dataSlice(index, data) {
      var open = (index - 1) * this.pageSize;
      var end = index * this.pageSize;
      return data.slice(open, end);
    },
    //格式化数据
    format(res) {
      var now = new Date();
      this.updateTimeText = format(now, "MM-dd HH:mm:ss");
    },
    webSocket() {
      var http = sessionStorage.getItem("http");
      var uuid = this.$route.query.key;
      if (http) {
        http += "/websocket/oee/monitoring";
      } else {
        http = "https://demo.biqs.cn/websocket/oee/monitoring";
      }

      http = http.replace("https", "wss").replace("http", "ws");

      this.websock = new WebSocket(http);
      this.websock.onopen = this.websocketonopen; //连接成功
      this.websock.onmessage = this.websocketonmessage; //广播成功
      this.websock.onerror = this.websocketonerror; //连接断开，失败
      this.websock.onclose = this.websocketclose;

      let this_ = this;
    },
    //连接成功
    websocketonopen() {
      console.log("Qplot socket 连接成功");
    },

    //连接失败
    websocketonerror() {
      console.log("Qplot socket 连接失败");
      this.reconnect();
    },

    //各种问题导致的 连接关闭
    websocketclose() {
      console.log(" Qplot socket 断开连接");
      this.reconnect();
    },
    //数据接收
    websocketonmessage(data) {

    },

    //断开重连
    reconnect() {
      if (this.lockReconnect) {
        return;
      }
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(() => {
        this.webSocket();
      }, 5000);
    },
    removeTAG(str) {
      if (str) {
        return str.replace(/<[^>]+>/g, "");
      } else {
        return str;
      }
    },
    formatDate(time) {
      if (time) {
        console.log(time);
        var date = new Date(Number(time));
        return format(date, "yyyy-MM-dd");
      }
      return "";
    },
    formatHour(time) {
      if (time) {
        var date = new Date(Number(time));
        return format(date, "MM/dd HH:mm");
      }
      return "";
    },
    back() {
      router.back();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='./board.css'></style>



// WEBPACK FOOTER //
// src/pages/oee/mm/register/board.vue